import { $groupingRules } from '@/services/'; // Import the service

export default {
  namespaced: true,

  state: () => ({
    rules: {
      data: []
    },
    loading: false,
    error: null,
  }),

  mutations: {
    SET_RULES(state, rules) {
      state.rules = rules;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    REMOVE_RULE(state, ruleId) {
      state.rules.data = state.rules.data.filter(rule => rule.id !== ruleId);
    },
    UPDATE_RULE(state, updatedRule) {
      const index = state.rules.data.findIndex(rule => rule.id === updatedRule.id);
      if (index !== -1) {
        state.rules.data.splice(index, 1, updatedRule);
      }
    },
    ADD_RULE(state, rule) {
      if (!Array.isArray(state.rules.data)) {
        state.rules.data = [];
      }
      state.rules.data.push(rule);
    }
  },

  actions: {
    async fetchRules({ commit }, { scope, id }) {
      commit("SET_LOADING", true);
      try {
        const service = scope === 'project' ? $groupingRules.forProject(id) : $groupingRules.forAccount();
        const response = await service.all();
        commit("SET_RULES", response.data);
        return response;
      } catch (error) {
        commit("SET_ERROR", error);
        console.error("Error fetching rules:", error);
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async createRule({ commit }, { scope, id, ruleData }) {
      commit("SET_LOADING", true);
      try {
        const service = scope === 'project' ? $groupingRules.forProject(id) : $groupingRules.forAccount();
        const response = await service.create(ruleData);
        commit("ADD_RULE", response.data);
      } catch (error) {
        commit("SET_ERROR", error);
        console.error("Error creating rule:", error);
        throw error;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async deleteRule({ commit }, { scope, id, ruleId }) {
      try {
        const service = scope === 'project' ? $groupingRules.forProject(id) : $groupingRules.forAccount();
        await service.delete(ruleId);
        commit("REMOVE_RULE", ruleId);
      } catch (error) {
        console.error("Error deleting rule:", error);
      }
    },

    async updateRule({ commit }, { scope, id, ruleId, payload }) {
      try {
        const service = scope === 'project' ? $groupingRules.forProject(id) : $groupingRules.forAccount();
        const response = await service.update(ruleId, payload);
        commit("UPDATE_RULE", response.data);
      } catch (error) {
        console.error("Error updating rule:", error);
      }
    }
  }
};
